/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:entitlements-pilet:solution-paywall */

export interface SolutionPaywallBlockParams {
	/**
	 * The entitlement definition of the resource identifier
	 */
	entitlementDefRID: string;
	/**
	 * Prevent navigating to the content when entitlement reaches a paywall. Default value is false.
	 */
	preventNavigationOnPaywall?: boolean;
}
/** Zone parameters for urn:zone:entitlements-pilet:solution-paywall:content */

export interface SolutionPaywallContentZoneParams {
	debug?: boolean;
}
/** Zone parameters for urn:zone:entitlements-pilet:solution-paywall:loading */

export interface SolutionPaywallLoadingZoneParams {
	debug?: boolean;
}

export namespace BlockNames {
	export const SolutionPaywall = 'urn:block:entitlements-pilet:solution-paywall' as const;
	export type SolutionPaywall = 'urn:block:entitlements-pilet:solution-paywall';
}

export namespace ZoneTypes {
	export const SolutionPaywallContent =
		'urn:zone:entitlements-pilet:solution-paywall:content' as const;
	export type SolutionPaywallContent =
		'urn:zone:entitlements-pilet:solution-paywall:content';
	export const SolutionPaywallLoading =
		'urn:zone:entitlements-pilet:solution-paywall:loading' as const;
	export type SolutionPaywallLoading =
		'urn:zone:entitlements-pilet:solution-paywall:loading';
}

export type SolutionPaywallProps = ShellProps & BlockParams & SolutionPaywallBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:entitlements-pilet:solution-paywall']: BlockParams &
			SolutionPaywallBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:entitlements-pilet:solution-paywall:content']: SolutionPaywallContentZoneParams;
		['urn:zone:entitlements-pilet:solution-paywall:loading']: SolutionPaywallLoadingZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:entitlements-pilet:solution-paywall:content']: never;
		['urn:zone:entitlements-pilet:solution-paywall:loading']: never;
	}
}
